import MaskedInput from "react-text-mask";

export const isNoData = (value) => {
  if (value === undefined || value === null || value === "NA" || value === "N/A" || value === -1) {
    return true;
  }
  return false;
};

export const compareNumber = (a, b) => {
  if (a > b) return 1;
  if (a < b) return -1;

  return 0;
};

export const descendingComparator = (a, b, orderBy) => {
  const isNumeric = (str) => /^[0-9]+$/.test(str);

  const aVal = String(a[orderBy]).trim();
  const bVal = String(b[orderBy]).trim();

  if (isNumeric(aVal) && isNumeric(bVal)) {
    return compareNumber(Number(aVal), Number(bVal));
  }

  if (!isNumeric(aVal) && !isNumeric(bVal)) {
    let regex = /(\d+)(\D+)/;
    let aMatch = aVal.match(regex);
    let bMatch = bVal.match(regex);

    if (aMatch && bMatch) {
      let [, aNumber, aText] = aMatch;
      let [, bNumber, bText] = bMatch;

      if (aText === bText) {
        return compareNumber(Number(aNumber), Number(bNumber));
      } else {
        return aText.localeCompare(bText);
      }
    } else {
      regex = /(\D+)(\d+)/;
      aMatch = aVal.match(regex);
      bMatch = bVal.match(regex);

      if (aMatch && bMatch) {
        let [, aText, aNumber] = aMatch;
        let [, bText, bNumber] = bMatch;

        if (aText === bText) {
          return compareNumber(Number(aNumber), Number(bNumber));
        } else {
          return aText.localeCompare(bText);
        }
      }
    }
    return aVal.localeCompare(bVal);
  }
  if (isNumeric(aVal)) return -1;
  if (isNumeric(bVal)) return 1;

  return 0;
};

/**
 * `descendingComparator`는 숫자/문자열 비교가 오름차순(작은 값 먼저)에 가깝게 동작한다.
 * 그래서 order === "desc"일 때 부호를 반전해야 UI의 desc(내림차순)와 실제 정렬이 일치한다.
 */
export const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => -descendingComparator(a, b, orderBy)
    : (a, b) => descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const phoneInputMask = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[1-9]/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask
    />
  );
};

export const zipcodeInputMask = (props) => {
  const { inputRef, ...other } = props;

  return (
      <MaskedInput
          {...other}
          ref={(ref) => {
            inputRef(ref ? ref.inputElement : null);
          }}
          mask={[
            /[0-9]/,
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ]}
          placeholderChar={"\u2000"}
          showMask
      />
  );
};

export const decodeRx = (msg) => {
  if(msg == null) return null;
  const binString = atob(msg);
  return new TextDecoder().decode(Uint8Array.from(binString, (m) => m.codePointAt(0)));
};

export const encodeTx = (msg) => {
  if(msg == null) return null;
  const binString = Array.from(new TextEncoder().encode(msg), (byte) =>
    String.fromCodePoint(byte),
  ).join("");
  return btoa(binString);
};
